import './Footer.css';

import React from "react";
// import "./../index.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <h2>
        Made with &nbsp;<i class="fas redd fa-heart"></i> by &nbsp;
        <a
          href="https://github.com/usamalearner"
          rel="noopener noreferrer"
          target="_blank"
        >
          Syed Usama Ali
        </a>{" "}
      </h2>
    </div>
  );
};

export default Footer;